module.exports = __webpack_public_path__ + "static/bg02-1a127d1d07c74440652a5b8bd2844d30.jpg";